import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const CartIcon = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <path d={"M36.675,3.425l3.283-14.444a1.667,1.667,0,0,0-1.625-2.036H11.056l-.637-3.112A1.667,1.667,0,0,0,8.787-17.5H1.667A1.667,1.667,0,0,0,0-15.833v1.111a1.667,1.667,0,0,0,1.667,1.667H6.52L11.4,10.794a3.889,3.889,0,1,0,4.656.595H30.613a3.888,3.888,0,1,0,4.417-.723l.383-1.686a1.667,1.667,0,0,0-1.625-2.036H15.147l-.455-2.222H35.05A1.667,1.667,0,0,0,36.675,3.425Z"} transform={"translate(4 23.5)"} fill={fill}/>
    </svg>
  );
};

CartIcon.defaultProps = {
  size: 48,
  fill: "#fff",
  className: "",
  id: ""
};

CartIcon.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
